import { doc, getDoc, getFirestore } from "firebase/firestore";

// Types
import { APYData, FeaturesData, MaxYieldData } from "types/common";

// Utils
import { sentryErrorLog } from "utils/sentryLog";

export const getAPYData = async () => {
  const db = getFirestore();

  const snapshot = await getDoc(doc(db, "binance", "details"));

  const response = snapshot.data() as APYData;

  const data = {
    baseAPY: response.baseAPY,
    staderBoost: response.staderBoost,
  };

  return data;
};

export const getMaxDefiYield = async () => {
  const db = getFirestore();

  const snapshot = await getDoc(doc(db, "binance", "maxDefiYieldStrategy"));

  const response = snapshot.data() as MaxYieldData;

  const data = {
    value: response.value,
    strategyPage: response.strategyPage,
    maxYieldStrategy: response.maxYieldStrategy,
  };

  return data;
};

export const subscribeEmail = async (data: FormData) => {
  try {
    const response = await fetch(
      "https://script.google.com/macros/s/AKfycbxdo569bZMkTsQHuE3qFzO2dEwpoyOly6MbAlVUU2YlM-kMYUxcUMGYxL1_cksL1UsiPQ/exec",
      {
        method: "POST",
        body: data,
        redirect: "follow",
      }
    );

    return response;
  } catch (error) {
    sentryErrorLog(error);
    return {
      error,
    };
  }
};

export const getFeaturesData = async () => {
  const db = getFirestore();

  const snapshot = await getDoc(doc(db, "binance", "features"));

  const response = snapshot.data() as FeaturesData;

  return response;
};
